export default __webpack_public_path__ + "static/banner-c952280ed3835f5df7e5778b4692b057.svg";